var app = angular.module('directives.search');

app.service('Services', [function () {
    var Services = {
        data: [],
        setData: function(data){
            Services.data = data;
        },
        getData: function(){
            return Services.data;
        }
    };

    return Services;
}]);

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/search/service.js
 ** module id = 219
 ** module chunks = 1
 **/